<template>
  <div class="app-savebar app-bar" :class="{ 'app-savebar--top': top }" role="region" aria-label="Ungespeicherte Änderungen">
    <span class="app-savebar__text">{{ text }}</span>
    <div class="app-savebar__actions">
      <app-button :disabled="saving" @click="$emit('discard')">Verwerfen</app-button>
      <app-button kind="primary" icon="check" :loading="saving" @click="$emit('save')">Speichern</app-button>
    </div>
  </div>
</template>

<script>
// Speichern-Leiste für Grids mit Batch-Editing (Spezifikation 2.10): sticky an der Unterkante des Blatts bzw. auf
// dem Handy über der unteren Navigation (bottom: var(--sticky-unten)). Mit v-if="hasChanges" direkt unter das Grid
// setzen:
//   <app-save-bar v-if="hasChanges" @save="saveChanges" @discard="revertChanges" />
// top (Tabellenseiten mit Fußleiste, Kundenwunsch 13.10.2026: „lieber über der tabelle“): über der Tabelle statt
// darunter, nicht klebend, Linie unten statt oben.
import AppButton from './AppButton.vue';

export default {
  name: 'AppSaveBar',
  components: { AppButton },
  props: {
    text: { type: String, default: 'Ungespeicherte Änderungen' },
    saving: { type: Boolean, default: false },
    top: { type: Boolean, default: false }
  }
};
</script>
